import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type IsOpenService from 'garaje/services/is-open';
import type StateService from 'garaje/services/state';

interface VirtualFrontDeskArgs {
  trackClickEvent: (trackingString: string) => void;
}

export default class SideBarLocationMenuVirtualFrontDeskComponent extends Component<VirtualFrontDeskArgs> {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare isOpen: IsOpenService;
  @service declare router: RouterService;
  @service declare state: StateService;

  @tracked vfdEnabled: boolean = false;

  constructor(...args: unknown[]) {
    // @ts-ignore
    super(...args);

    void this.loadVfdEnabled();
  }

  get canViewDeviceAlertsNav(): boolean {
    return this.abilities.can('update printer notifications') || this.abilities.can('update device notifications');
  }

  get isOnLandingPage(): boolean {
    const currentPage = this.router.currentRouteName;
    return currentPage === 'virtual-front-desk.landing-page';
  }

  @action
  async loadVfdEnabled(): Promise<void> {
    const vfdConfiguration = await this.state.currentLocation?.getVfdConfiguration();
    this.vfdEnabled = vfdConfiguration?.enabled ?? false;
  }
}
